// extracted by mini-css-extract-plugin
module.exports = {"Soon":"Soon_Soon__2qKyl","SoonText":"Soon_SoonText__39pwX"};